"use client";

import Journal from "@/src/_types/journal";
const OnlineChat = ({ journal }: { journal: Journal }) => {
    return(
        <>
            {/* We did not implement Comm100 Live Chat because it is not being used. */}
        </>
    );
}

export default OnlineChat;
